<script>
const { VUE_APP_API_HOST } = process.env   

export default {
  data() {
    return {
      plans : {
        "free" : {
            "price" : {
                "currentPrice" : {monthly: 0, annualy: 0},
                "oldPrice" : {monthly: 0, annualy: 0}
            },

            "condition" : {
              "user" : (amount)=> amount <= 1,
              "network" : (amount)=> amount <= 1,
              "sources" : (amount)=> amount <= 1,
              "maxUser" : 1,
              "maxNetwork" : 1,
              "maxSources" : 1,
            },

            "nbrUtilisateur" : 1,
            "nbrPages" : 1,
        },
        "starter" : {
          "price" : {
              "currentPrice" : {monthly: 20, annualy: 200},
              "oldPrice" : {monthly: 9.99, annualy: 95.90}
          },

          "condition" : {
              "user" : (amount)=> amount <= 5,
              "network" : (amount)=> amount <= 10,
              "sources" : (amount)=> amount <= 10,
              "maxUser" : 5,
              "maxNetwork" : 10,
              "maxSources" : 10,
          },

          "nbrUtilisateur" : 5,
          "nbrPages" : 10,

          "option" : {
              "conciergerie" : 100,
              "reporting" : 50
          }  
        },
        "standard" : {
            "price" : {
                "currentPrice" : {monthly: 120, annualy: 1200},
                "oldPrice" : {monthly: 89.99, annualy: 854.40}
            },

            "condition" : {
                  "user" : (amount)=> amount <= 50,
                  "network" : (amount)=> amount <= 60,
                  "sources" : (amount)=> amount <= 60,
                  "maxUser" : 50,
                  "maxNetwork" : 60,
                  "maxSources" : 60,
            },

            "nbrUtilisateur" : 50,
            "nbrPages" : 60,

            "option" : {
                "conciergerie" : 150,
                "reporting" : 0
            }
        },
        "premium" : {
          "price" : {
            "currentPrice" : {monthly: 600, annualy: 6000},
            "oldPrice" : {monthly: 149.99, annualy: 1430.40}
          },

          "condition" : {
            "user" : (amount)=> amount <= 200,
            "network" : (amount)=> amount <= 250,
            "sources" : (amount)=> amount <= 250,
            "maxUser" : 200,
            "maxNetwork" : 250,
            "maxSources" : 250,
          },

          "nbrUtilisateur" : 200,
          "nbrPages" : 250,

          "option" : {
            "conciergerie" : 0,
            "reporting" : 0
          }
        },
      },
    }
  },
  methods: {
    subscribePlan(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/subscriptions`,
          body,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(res => res, err => err)
    },

    subscribeOption(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/subscriptions/option`,
          body,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(res => res, err => err)
    },

    removeOption(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/subscriptions/option/remove`,
          body,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(res => res, err => err)
    },

    getPricePlan(user) {
      let price = 0;
      let userPrenium = user._premium;
      if (user._premium && userPrenium.plan > 0 && userPrenium.active) {
        let nameCurrentPlan = userPrenium.plan ? Object.keys(this.plans)[userPrenium.plan] : 'free';
        let is_old_offer = userPrenium.is_old_offer || false;
        let is_annual = userPrenium.is_annual || false;
        let discount = (userPrenium.discount || 0) / 100;  //convert centime en euro
        price = (this.plans[nameCurrentPlan].price[is_old_offer ? 'oldPrice' : 'currentPrice'][is_annual ? 'annualy' : 'monthly'] - discount);    

        if(userPrenium.options_plan && userPrenium.options_plan.length){
            for(let option of userPrenium.options_plan)
            price += this.plans[nameCurrentPlan].option[option] * (is_annual ? 10 : 1)
        }
      }
      return Number.isInteger(price) ? price : price.toFixed(2);
    },
  }
}
</script>